import React, { useState } from "react";
import { saveUser, getDashboardUrl } from "../../utils/auth";

function Signup() {
  const [formData, setFormData] = useState({ name: "", email: "", mobile: "" });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name || !formData.email || !formData.mobile) {
      setError("Please fill in all fields");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError("Please enter a valid email address");
      return;
    }

    if (!/^\d{10}$/.test(formData.mobile.replace(/\D/g, ""))) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    // Save user credentials
    saveUser(formData.email, formData.name);

    // Redirect immediately to the dashboard
    window.location.href = getDashboardUrl();
  };

  return (
    <div className="container signup-page">
      <section className="signup-card">
        <div className="signup-panel">
          <h1>Open your Zerodha account</h1>
          <p>
            Join the modern investment platform with transparent pricing, simple
            onboarding, and powerful tools for every investor.
          </p>
          <div className="signup-stat-row">
            <div className="signup-stat">
              <strong>₹0</strong>
              <span>Delivery trades</span>
            </div>
            <div className="signup-stat">
              <strong>₹20</strong>
              <span>Intraday & F&O</span>
            </div>
          </div>
        </div>
        <form className="signup-form" onSubmit={handleSubmit}>
          <label>
            Full name
            <input 
              type="text" 
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
            />
          </label>
          <label>
            Email address
            <input 
              type="email" 
              name="email"
              placeholder="you@example.com"
              value={formData.email}
              onChange={handleChange}
            />
          </label>
          <label>
            Mobile number
            <input 
              type="tel" 
              name="mobile"
              placeholder="+91 98765 43210"
              value={formData.mobile}
              onChange={handleChange}
            />
          </label>
          {error && <p className="form-error">{error}</p>}
          <button type="submit" className="btn btn-primary">
            Create account
          </button>
        </form>
      </section>
    </div>
  );
}

export default Signup;
